import { Routes, Route, Navigate } from 'react-router-dom';
import { lazy, Suspense } from 'react';
import { View, Spinner } from '@smarterservices/smarter-ui';
import VirtualTestCenter from './VirtualTestCenter';
import LoginScreen from './Login';
import TwilioSyncView from './Sync';
import Rooms from './Rooms';
import NotFound from './NotFound';
import { AuthProvider, ProtectedRoute } from '../context/AuthContext';

// Loading component
const Loading = () => (
  <View as="div" textAlign="center">
    <Spinner renderTitle="Loading" size="large" />
  </View>
);

const VtcRoutes = () => {
  return (
    <Suspense fallback={<Loading />}>
        <AuthProvider>
      <Routes>
          {/* Set the default page to go to the Virtual Test Center */}
          <Route path="/" element={<LoginScreen />} />
          <Route path="/vtc" element={<LoginScreen />} />

          <Route
            path="/rooms"
            element={
              <ProtectedRoute>
                <Rooms />
              </ProtectedRoute>
            }
          />

          {/* Since we will be updating the path so we can trigger external scripts, just set as a wildcard */}
          <Route
            path="/rooms/:roomId/*"
            element={
              <ProtectedRoute>
                <VirtualTestCenter />
              </ProtectedRoute>
            }
          />
          <Route path="/sync/*" element={<TwilioSyncView />} />

          {/* 404 Route */}
          <Route path="*" element={<NotFound />} />
        </Routes>
        </AuthProvider>
    </Suspense>
  );
};

export default VtcRoutes;
